export const routes = (parentName) => {
  return [
    {
      path: "payment",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Payment`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-Payment-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "list-special",
          name: `${parentName}-Payment-List-Special`,
          component: () => import("./ListSpecial.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "list-deposit",
          name: `${parentName}-Payment-List-Deposit`,
          component: () => import("./ListDeposit.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "detailes",
          name: `${parentName}-Payment-List-Detailes`,
          component: () => import("./ListDeatilesPayment.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "list-lunch",
          name: `${parentName}-Payment-List-Lunch`,
          component: () => import("./ListLunch.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Payment-New`,
          component: () => import("./Upsert.vue"),
        },

        {
          path: ":id/edit",
          name: parentName + "-" + "Payment-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
